import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Training Target")
], -1)
const _hoisted_5 = {
  class: "d-flex justify-content-end",
  style: {"align-items":"left"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = { class: "row fs-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Parent Entity (e.g. Association, Ministry, etc.)", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "card mb-5 mb-xl-10" }
const _hoisted_12 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#assessor_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_13 = { class: "row mt-1 w-100 m-0" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "div pb-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control ps-10 w-200px mt-1 form-control-sm",
  style: {"height":"1em"},
  placeholder: "Search"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-6 mt-1 text-end\" data-v-54b12dc8=\"\"><button type=\"button\" class=\"btn btn-dark fs-7 p-2 rounded-0\" title=\"Download Xlse\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-excel fs-5\" data-v-54b12dc8=\"\"></i> Excel </button><button type=\"button\" class=\"btn btn-warning fs-7 p-2 rounded-0\" title=\"Download PDF\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-pdf fs-5\" data-v-54b12dc8=\"\"></i> PDF </button><button type=\"button\" class=\"btn btn-primary fs-7 p-2 rounded-0\" title=\"Download CSV\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-csv fs-5\" data-v-54b12dc8=\"\"></i> CSV </button></div>", 1)
const _hoisted_18 = {
  id: "assessor_data",
  class: "collapse show"
}
const _hoisted_19 = { class: "collapse show" }
const _hoisted_20 = { class: "card-body border-top p-6" }
const _hoisted_21 = {
  class: "current",
  "data-kt-stepper-element": "content",
  id: "datatableId"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt text-light" }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-light" }, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  class: "modal fade",
  id: "industry_details",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_32 = { class: "modal-dialog mw-650px" }
const _hoisted_33 = { class: "modal-content" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header",
  id: "kt_modal_add_type_header"
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-light" }, "Add Training Target"),
  /*#__PURE__*/_createElementVNode("div", {
    id: "kt_modal_add_type_close",
    "data-bs-dismiss": "modal",
    class: "btn btn-icon btn-sm btn-active-icon-primary"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
  ])
], -1)
const _hoisted_35 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_36 = { class: "table-responsive mt-5" }
const _hoisted_37 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Entity Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Tranche"),
    /*#__PURE__*/_createElementVNode("th", null, "Year"),
    /*#__PURE__*/_createElementVNode("th", null, "Target Trainee Number")
  ])
], -1)
const _hoisted_39 = { class: "fw-bold" }
const _hoisted_40 = { class: "fw-bold" }
const _hoisted_41 = { class: "fw-bold" }
const _hoisted_42 = { class: "fw-bold" }
const _hoisted_43 = { class: "fw-bold" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_SearchTable = _resolveComponent("SearchTable")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_TypeModal = _resolveComponent("TypeModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args))),
              type: "button",
              class: "btn btn-primary",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_add_type"
            }, [
              _hoisted_6,
              _createTextVNode(" Add New ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_select, {
            class: "form-select-solid",
            placeholder: "Select Entity Type",
            modelValue: _ctx.entity_type_id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity_type_id) = $event)),
            filterable: "",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityTypes, (types) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: types.id,
                  label: types.name,
                  value: types.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(types.name), 1)
                  ]),
                  _: 2
                }, 1032, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_SearchTable, { tableId: _ctx.datatableId }, null, 8, ["tableId"])
                  ])
                ]),
                _hoisted_17
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Datatable, {
                      "table-data": _ctx.tableData,
                      "table-header": _ctx.tableHeader,
                      "enable-items-per-page-dropdown": true
                    }, {
                      "cell-id": _withCtx(({ row }) => [
                        _createTextVNode(_toDisplayString(row.id), 1)
                      ]),
                      "cell-name": _withCtx(({ row: industry }) => [
                        _createTextVNode(_toDisplayString(industry.name), 1)
                      ]),
                      "cell-entity_type_level": _withCtx(({ row: industry }) => [
                        _createTextVNode(_toDisplayString(industry.entity_type_level), 1)
                      ]),
                      "cell-description": _withCtx(({ row: industry }) => [
                        _createTextVNode(_toDisplayString(industry.description), 1)
                      ]),
                      "cell-actions": _withCtx(({ row: industry }) => [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.view(industry)),
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#industry_details",
                          class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1"
                        }, _hoisted_24, 8, _hoisted_22),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.edit(industry)),
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_add_type",
                          class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                        }, _hoisted_27, 8, _hoisted_25),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.Delete(industry.id)),
                          class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm"
                        }, _hoisted_30, 8, _hoisted_28)
                      ]),
                      _: 1
                    }, 8, ["table-data", "table-header"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("table", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.data.name), 1),
                    _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.data.entity_type_level), 1),
                    _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.data.description), 1),
                    _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.data.description), 1),
                    _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.data.description), 1)
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_44
        ])
      ])
    ]),
    _createVNode(_component_TypeModal)
  ], 64))
}